<form [formGroup]="formData" novalidate (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body factory_admin">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="">SKU</label>
          <ng-select
            [items]="rfqs"
            formControlName="sku"
            [hideSelected]="true"
            [trackByFn]="trackByFn"
            [loading]="rfqLoading"
            [typeahead]="rfqInput$"
          >
            <ng-template ng-label-tmp let-item="item">
              [{{ item.sku ?? item.internal_sku }}] {{ item.product_name }}
            </ng-template>
            <ng-template
              ng-option-tmp
              let-item="item"
              let-index="index"
              let-search="searchTerm"
            >
              [{{ item.sku }}] {{ item.product_name }}
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>
    <h4 *ngIf="rfq_ids && rfq_ids.length > 0" class="selected text-center">
      {{ rfq_ids.length }} SKUs selected
    </h4>
    <mat-checkbox
      class="px-2"
      color="primary"
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="retainSku"
    >
      Retain SKU of all selected/consolidated SKUs
    </mat-checkbox>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-danger"
      (click)="activeModal.dismiss('')"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>
    <button
      type="button"
      (click)="createMasterRfq()"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      [disabled]="loading"
      class="btn btn-info btn-elevate"
    >
      <i class="fas fa-plus"></i> Create New Master SKU
    </button>
    <button
      type="button"
      (click)="onSubmit()"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      [disabled]="loading"
      id="kt_submit"
      class="btn btn-success btn-elevate"
    >
      <i class="fas fa-save"></i> Confirm
    </button>
  </div>
</form>
